import { SecurityService } from '../../../services/security';
import { RaporApiBase } from '../../core/ApiBase';

export default class SirketBazliKiraIcmalRapor extends RaporApiBase {
  constructor(id: number, sirketAdi: string) {
    super();
    this._MethodUrl = SecurityService.URLSafeParams([
      { name: 'RaporTuru', value: 'SirketBazliKiraIcmalRapor' },
      { name: 'ID', value: id },
      { name: 'SirketAdi', value: sirketAdi }
    ]);
  }
}
